import React from 'react';

export default (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="28" height="28" fill="#8BC34B" />
		<path
			d="M25.2656 2.73438V25.2656H2.73438V2.73438H25.2656ZM3.31771 24.6823H24.6823V3.31771H3.31771V24.6823Z"
			fill="#496627"
		/>
	</svg>
);
